import React from 'react'
import PropTypes from 'prop-types'

const Required = (props) => {
  return (
    <span>
      { props.required && (<label className='element-required-color'>&nbsp;*</label>) }
    </span>
  )
}

Required.propTypes = {
  required: PropTypes.bool
}

export default Required
